export const artistsList = [
  { id: 1, name: "Poonam Mishra", genre: "Maithili Folk", category: "Maithili Folk", img: "/images/Poonam Mishra.jpg" },

  { id: 2, name: "Kumkum Mishra", genre: "Maithili Folk", category: "Maithili Folk", img: "/images/Kumkum Mishra copy.jpg" },

  { id: 3, name: "Madhav Rai", genre: "Maithili Folk", category: "Maithili Folk", img: "/images/Madhav Rai new.png" },

  { id: 4, name: "Dilip Darbhangiya", genre: "Maithili Classical", category: "Maithili Folk", img: "/images/Dilip Darbhangiya.png" },

  { id: 5, name: "Ram Babu Jha", genre: "Maithili Folk", category: "Maithili Folk", img: "/images/Ram Babu Jha.jpg" },

  // FIXED (was wrong earlier)
  { id: 6, name: "Kunj Bihari Mishra", genre: "Maithili Folk", category: "Maithili Folk", img: "/images/Kunj Bihari Mishra copy.png" },

  // ❌ No image found → keep placeholder or remove
  // { id: 7, name: "Rashmi Dutt", genre: "Bhakti & Hindi Devotional", category: "Hindi Devotional", img: "/images/default.jpg" },

  // FIXED (jfif file)
  { id: 8, name: "Salim Miyan", genre: "Sufi & Folk", category: "Sufi & Folk", img: "/images/Salim Miyan.jfif" },

  // Now mapping rest from your folder 👇

  { id: 9, name: "Bijender Giri", genre: "Bhojpuri Folk", category: "Bhojpuri Folk", img: "/images/Bijender Giri (2).jpg" },

  { id: 10, name: "Badal Bawali", genre: "Bhojpuri Folk", category: "Bhojpuri Folk", img: "/images/Badal Bawali 02.jpg" },

  { id: 11, name: "Maya Upadhay", genre: "Hindi Hindi Devotional", category: "Hindi Hindi Devotional", img: "/images/Maya Upadhay 2.jpg" },

  // { id: 12, name: "Manager Byas", genre: "Maithili Classical", category: "Maithili Folk", img: "/images/Director Photo (Manmohan Sharma).jpg" },

  // { id: 13, name: "Rashmi Yogini", genre: "Spiritual & Yoga", category: "Hindi Devotional", img: "/images/Meenu Arora.jpg" },

  // { id: 14, name: "Ramashankar Yadav", genre: "Bhojpuri Folk", category: "Bhojpuri Folk", img: "/images/Ram Babu Jha.jpg" },

  // { id: 15, name: "Avinash Karn", genre: "Maithili Pop", category: "Maithili Folk", img: "/images/Udit Narayan 0122 (2).jpg" },

  { id: 16, name: "Guddu Rangila", genre: "Bhojpuri Entertainment", category: "Bhojpuri Folk", img: "/images/Guddu Rangeela.jpg" },

  { id: 17, name: "Suresh Wadkar", genre: "Bollywood Playback", category: "Bollywood Playback", img: "/images/Suresh Wadekar.jpg" },

  { id: 18, name: "Ravindra Jain", genre: "Film Music", category: "Bollywood Playback", img: "/images/Ravindra Jain.jpg" },

  { id: 19, name: "Sadhna Sargam", genre: "Bollywood Playback", category: "Bollywood Playback", img: "/images/Sadhna Sargam.jpg" },

  { id: 20, name: "Swastika Mishra", genre: "Hindi Hindi Devotional", category: "Hindi Hindi Devotional", img: "/images/Swastica K Mishra (9).png" },

  { id: 21, name: "Sonu Nigam", genre: "Bollywood Playback", category: "Bollywood Playback", img: "/images/Sonu Nigam.jpg" },

  { id: 22, name: "Praveen Samrat", genre: "Bhojpuri Pop", category: "Bhojpuri Folk", img: "/images/Praveen Samrat.jpg" },

  { id: 23, name: "Alka Yagnik", genre: "Bollywood Playback", category: "Bollywood Playback", img: "/images/Alka Yagnik.jpg" },
];

export const artistCategories = ["All", "Bhojpuri Folk", "Maithili Folk", "Hindi Devotional", "Bollywood Playback", "Classical Vocal", "Sufi & Folk"];
